var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.blockUser),expression:"blockUser"}],staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container is-centered"},[_c('span',[_vm._v(_vm._s(_vm.ehrText.mustSignIn))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }